import styled from 'styled-components';
import IcoOpenMenu from '../../assets/menu/open.svg';
import IcoCloseMenu from '../../assets/menu/close.svg';

export const HeaderStyle = styled.header`
  position: fixed;
  display: flex;
  width: 100%;
  padding: 20px 0;
  background: #007e78;
  align-items: center;
  z-index: 1;

  div {
    justify-content: space-between;

    img {
      width: 160px; 
    }
  }

  &.dash {
    background: #fff;
  }

  &.login {
    background: #fff;
    .logo {
      display: none;
    }
  }

  @media(max-width: 800px) {
    height: 60px;
    padding: 0 30px;

    div {
      align-items: center;
    }

    .overlay {
      position: fixed;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100vh;
      background-color: rgba(2, 0, 0, 0.8);
      z-index: 1;
    }
  }
`;

export const Menu = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;

  .logoMobile { display: none; }

  li {
    display: flex;
    align-items: center;

    a {
      color: #fff!important;
      margin: 0 5px;

      &.active {
        text-decoration: underline;
      }

      &:hover {
        color: #fff;
        text-decoration: underline;
      }
    }
  }

  .toDash {
    margin: 0 15px;
    padding-left: 10px;
    border-left: 2px solid #fff;

    .toDash--link {
      position: relative;
      display: inline-block;
      width: 100px;
      color: #000;
      font-size: 14px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      cursor: pointer;
    }

    i {
      position: absolute;
      width: 15px;
      height: 15px;
      top: 7px;
      right: -7px;

      &:after, &:before {
        display: block;
        position: absolute;
        content: '';
        width: 1px;
        height: 10px;
        background: #000;
      }
      &:after {
        right: 8px;
        transform: rotate(40deg)
      }
      &:before {
        transform: rotate(-40deg)
      }
    }

    .toDash--menu {
      position: absolute;
      top: 35px;
      min-width: 120px;
      text-align: center;
      padding: 10px 10px;
      background: #fff;
      border: 1px solid #007e78;
      z-index: 1;

      a {
        font-size: 14px;
        color: #007e78!important;
      }
    }
  }

  @media(max-width: 800px) {
    position: absolute;
    display: ${props => props.open ? 'flex' : 'none'};
    height: 100vh;
    width: 90%;
    top: -16px;
    right: -30px;
    flex-direction: column;
    align-items: flex-end;
    background: #007e78;
    margin-left: auto;
    border-bottom-left-radius: 220px;
    box-shadow: 0px 0px 10px 0px black;
    z-index: 2;

    .logoMobile {
      display: inline-block;
      margin: 30px 10px 30px 0;
    }

    li {
      a {
        width: 100%;
        padding: 20px 10px 20px 0;
        text-align: right;
      }
    }
  }
`;

export const OpenMenu = styled.div`
  display: none;
  width: 33px;
  height: 20px;
  background: url(${IcoOpenMenu}) top center no-repeat;
  cursor: pointer;

  @media(max-width: 800px) {
    display: inline-block;
  }
`;

export const CloseMenu = styled.div`
  display: none;
  width: 33px;
  height: 33px;
  background: url(${IcoCloseMenu}) top center no-repeat;
  margin: 30px 10px 30px 0;
  cursor: pointer;

  @media(max-width: 800px) {
    display: inline-block;
  }
`;

export const Button = styled.button`
  font-size: 14px;
  color: #007e78!important;
  background: none;
  border: none;
`;